import { useCallback, useState } from 'react'

import { getAppInfo } from 'common'
import { Routes } from 'common/constants'
import { logBridgeError, sendSelectContent } from 'common/helpers'
import { useScreenFinishLoadTac } from 'common/hooks/useScreenFinishLoadTac'
import { useAppContext } from 'contexts/app-context/hooks'
import { TLanguage, TUserType } from 'contexts/app-context/types'

import { interWbNavigate } from '@interco/inter-webview-bridge'

import { setFallbackUnavailableContent } from '../utils/helpers'

export function useUnavailableFeature() {
  const { userSelectedEntity } = useAppContext()
  const [isLoading, setIsLoading] = useState(true)
  const [userLanguage, setUserLanguage] = useState<TLanguage>()
  const [userOrganization, setUserOrganization] = useState<TUserType>()

  getAppInfo()
    .then(({ language, organization }) => {
      setUserLanguage(language)
      setUserOrganization(organization)
    })
    .finally(() => {
      setIsLoading(false)
    })

  const content = setFallbackUnavailableContent(userLanguage, userOrganization)

  useScreenFinishLoadTac({
    name: 'UnavailableFeature',
    screen: Routes.UNAVAILABLE_FEATURE,
    action: 'UnavailableFeatureFinishLoad',
    entity: userSelectedEntity,
    shouldSend: !isLoading && !!content,
    logLabel: 'send unavailable feature finish tac',
  })

  const onclick = useCallback(async () => {
    try {
      await sendSelectContent({
        flow: 'unavailable_feature',
        step: 'unavailable_feature',
        screen_name: Routes.UNAVAILABLE_FEATURE,
        element_name: 'closeUnavailableFeature',
        element_type: 'button',
        parent_name: 'UnavailableFeature',
        scenario: JSON.stringify({
          screen: Routes.UNAVAILABLE_FEATURE,
          product: userSelectedEntity,
          ref_type: 'button',
          content_action: 'touch',
        }),
      })
    } catch (error: unknown) {
      logBridgeError('send unavailable feature close tic', error)
    }

    interWbNavigate.requestGoBack()
  }, [userSelectedEntity])

  return {
    content,
    isLoading,
    isActive: true,
    onclick,
  }
}
